import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {AppConfigService} from "projects/nter-ui-kit/src/lib/framework/config/app-config.service";
import {AdminContextService} from "projects/admin-portal/src/app/security/admin-context.service";
import {lastValueFrom} from "rxjs";

@Injectable({
  providedIn: 'root'
})
//todo move all loading of user methods here, and give impl in each web app.
export class AdminAuthorizationService {

  private readonly environment: any;

  constructor(private http: HttpClient,
              private currentContext: AdminContextService,
              config: AppConfigService) {
    this.environment = config.environment;
  }

  /**
   * Calls the local loadUserGrants() method as a synchronous call using a promise, waits on the response
   * and if successful, sets the user grants in the contextService using context.userGrants(grants[]);
   */
  public async refreshUserGrants(): Promise<void> {
    try {
      this.currentContext.userGrants = await this.loadUserGrants();
    } catch (error) {
      console.error('Error loading user grants', error);
      this.currentContext.reset();
      // Grants failed to load, so nothing authorises the stored selection — drop it
      // explicitly (reset() no longer does, see TF-6).
      this.currentContext.resetSelectedContext();
    }
  }

  private loadUserGrants(): Promise<any> {
    return lastValueFrom(this.http.get(this.environment.apiSecurityHost + '/admin/rbac/user/features'));
  }
}
